import PropTypes from 'prop-types';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';

const propTypes = {
	data: PropTypes.array,
};

function Results(props) {
	const history = useHistory();
	const rows = props.data.map((record) => {
		const handleRowClick = () => {
			history.push(`/admin/admin-groups/${record._id}`);
		};

		return (
			<tr key={record._id} onClick={handleRowClick}>
				<td>
					<Link
						className="btn btn-default btn-sm"
						to={`/admin/admin-groups/${record._id}`}
					>
						Edit
					</Link>
				</td>
				<td>{record.name}</td>
				<td className="nowrap">{record._id}</td>
			</tr>
		);
	});

	return (
		<div className="table-responsive">
			<table className="table table-striped table-results">
				<thead>
					<tr>
						<th></th>
						<th className="stretch">name</th>
						<th>id</th>
					</tr>
				</thead>
				<tbody>{rows}</tbody>
			</table>
		</div>
	);
}

Results.propTypes = propTypes;

export default Results;
